/* eslint-disable @typescript-eslint/no-explicit-any */
export interface UpdateDataFieldRequest {
  code?: string;
  value?: string | boolean;
}

export interface UpdateDataRequest {
  fields?: UpdateDataFieldRequest[];
  user_data_token?: string;
}

export interface GenericResponse {
  message?: string;
  title?: string;
  response?: 'OK' | 'KO';
  esito?: 'OK' | 'KO' |'true' | 'false' | boolean;
  detail?: string;
}

export interface DownloadRequestResponse extends Omit<GenericResponse, "response"> {
  response?: 'OK' | 'KO';
  status: "NOT_PRESENT" | "PENDING" | "PROCESSED" | "ERROR",
}

export interface DownloadReadyResponse extends Omit<GenericResponse, "response"> {
  response?: 'OK' | 'KO';
  status: "READY";
  link: string;
}

export type DownloadResponse = DownloadRequestResponse | DownloadReadyResponse;

export interface ReportsRequest {
  emailSender: string;
  message?: string;
  subject: string;
  domainApiKey: string;
  referrer: string;
  'g-recaptcha-response': string;
}

export interface UpdateRequest {
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthDate?: string;
  image?: string;
}

export interface RefreshTokenRequest {
  domainApiKey: string;
  accessToken?: string,
  refreshToken: string;
  appId?: string;
}

export interface RefreshTokenResponse {
  token: string;
  user_update?: Array<UserUpdate>;
  user_data_update?: UserDataUpdate;
}

export interface RegistrationRequest {
  password: string;
  email: string;
  lastName: string;
  firstName: string;
  domainApiKey: string;
  gender: string;
  birthDate: string;
  privacyPolicy?: boolean;
  personalizzazione?: boolean;
  pubblicitaProfilata?: boolean;
  ente?: boolean;
  socialUID?: string;
  socialProvider?: string;
  loginProvider?: string;
}

interface IDateString {
  readonly DateString: unique symbol
}
export type DateString = string & IDateString;

interface IDateTimeString {
  readonly DateTimeString: unique symbol
}
export type DateTimeString = string & IDateTimeString;

export interface RegistrationResponse extends GenericResponse {
  ua?: string;
  authorization?: string;
  refreshToken?: string;
  ente_accreditato?: boolean;
  social?: Social;
  raisso?: UserDetail;
}

export interface Social {
  loginProvider: string;
  photoURL?: string | null;
  thumbnailURL?: string | null;
}

export const genders = ['M', 'F', 'A'] as const;
export type Gender = typeof genders[number];

export interface ParentalControl {
  pin: string;
  level: number;
  created_date: DateTimeString;
  last_modified_date: DateTimeString | null;
}

export interface UserDetail {
  ua: string;
  age: number;
  birthDate: DateString;
  gender: Gender;
  uid: number;
  firstName: string;
  lastName: string;
  email: string;
  lid: string;
  photoURL?: string | null;
  userDomain: { refreshToken: string };
  lastToken?: DateTimeString | null;
  pubblicitaProfilata?: boolean;
  pubblicitaProfilataV?: string | null;
  privacyPubblicita?: boolean;
  privacyPolicy?: boolean;
  personalizzazione?: boolean;
  privacy_Policy_isAccepted?: boolean;
  privacy_Pubblicita_isAccepted?: boolean;
  user_update?: Array<UserUpdate> | null;
  user_data_update?: UserDataUpdate | null;
  parental_control?: ParentalControl | null;
}

export interface PrivacyResponse {
  message?: string;
  title?: string;
  response?: string;
  detail?: string;
  esito?: 'OK' | 'KO' |'true' | 'false' | boolean;
  pubblicitaProfilata?: boolean;
  pubblicitaProfilataV?: string;
  privacyPubblicita?: boolean;
  privacyPolicy?: boolean;
  personalizzazione?: boolean;
  privacy_Policy_isAccepted?: boolean;
  privacy_Pubblicita_isAccepted?: boolean;
}

export interface PubblicitaProfilataRequest {
  pubblicitaProfilata: boolean;
}

export interface PersonalizzazioneRequest {
  personalizzazione: boolean;
}

export interface DeleteRequest {
  uid: string;
  type?: string;
  domainApiKey?: string;
}

export interface UpdatePrivacyDataRequest {
  fields: Array<UpdatePrivacyFieldRequest>;
  user_data_token?: string;
}

export interface UpdatePrivacyFieldRequest {
  code?: string;
  value?: boolean;
}

export interface OauthResponse {
  scope?: string;
  refresh_token?: string;
  access_token?: string;
  expires_in?: number;
  token_type?: string;
}

export interface OauthGenericResponse {
  message?: string;
  path?: string;
  code?: number;
}

export interface OauthLoginRequest {
  email: string;
  password: string;
  domainApiKey: string;
  scope?: string;
  state?: string;
  response_type?: string;
}

export interface OauthCodeResponse {
  code?: string;
  state?: string;
  redirect_uri?: string;
}

export interface FieldOption   {
  key?: string;
  value?: string;
}

export interface LoginResponseLogin extends GenericResponse {
  ua?: string;
  authorization?: string;
  refreshToken?: string;
  ente_accreditato?: boolean;
  social?: SocialLogin;
  raisso?: UserDetailLogin;
  user_data_update?: UserDataUpdate;
  user_update?: Array<UserUpdate> | null;
}

export type SocialLogin = Social;

export const userDataUpdateFieldTypes = ['TEXT', 'SELECT', 'DATE', 'CHECKBOX', 'EMAIL', 'DATETIME', 'RADIO', 'BUTTON'] as const;
export type UserDataUpdateFieldType = typeof userDataUpdateFieldTypes[number];

export const userDataUpdateFieldSubtypes = ['BOOLEAN', 'STRING', 'AGE'] as const;
export type UserDataUpdateFieldSubtype = typeof userDataUpdateFieldSubtypes[number];

export interface UserDataUpdateField {
  index?: number;
  type?: UserDataUpdateFieldType;
  subType?: UserDataUpdateFieldSubtype;
  label?: string;
  code?: string;
  format?: string;
  values?: Array<FieldOption>;
  validators?: Record<string, string>;
  current_value?: string;
}

export interface UserUpdate {
  title?: string;
  name?: string;
  message?: string;
  submit?: string;
  footer?: string;
  user_data_token?: string;
}

export interface UserDataUpdate extends UserUpdate {
  fields?: Array<UserDataUpdateField>;
}

export type UserDetailLogin = UserDetail;

export interface LoginRequestLogin {
  domainApiKey: string;
  email: string;
  password: string;
  appId?: string;
  ente?: boolean;
}

export interface DeviceResponse {
  message?:	string
  title?:	string
  response?: string
  detail?: string
  esito?:	'OK' | 'KO' | 'true' | 'false' | boolean
  rtkn?: string
  appID?: number
  pin?: number
  qrCode?: string
  url?: string
}

export interface DeviceRequest {
  appID?: number;
  marca?: string
  modello?: string
  deviceID?: string
  pin?: number
  userId?: number
  domainApiKey?: string
}

export interface Device {
  id?: number
  brand?: string
  model?: string
  'model-id'?: string
  domain?: string
  users?: Array<number>
  created?: DateString
  modified?: DateTimeString
}

export interface PubblicitaProfilataResponse {
  pubblicitaProfilata?: boolean
  pubblicitaProfilataV?: string
  privacyPubblicita?: boolean
  privacy_Pubblicita_isAccepted?: boolean
}

export interface PersonalizzazioneResponse {
  personalizzazione?: boolean;
}

export interface DeviceDetail {
  uid: number
  marca?: string
  modello?: string
  deviceID?: string
  dataCreazione?: DateTimeString
  dataModifica?: DateTimeString
  dominio?: string
}

export interface UserDataInfoResponse {
  id?: number;
  email?: string;
  userDataUpdates?: Array<UserDataUpdateDetail>;
}

export interface UserDataUpdateDetail {
  userId?: number;
  created?: DateTimeString;
  field?: string;
  oldValue?: string;
  newValue?: string;
  'transaction-id'?: number;
}

export interface ParentalControlUpdatePinRequest {
  currentPin: string;
  newPin: string;
  confirmNewPin: string;
  level: string;
}

export interface ParentalControlLevelRequest {
  currentPin: string;
  level: number;
}

export interface ParentalControlResetPinRequest {
  newPin: string;
  confirmNewPin: string;
}
